import { useState } from 'react';
import { HandleTableData } from '@wajeez-web/components/data-table';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import {
  useBusinessSelector,
  BusinessActions,
} from '@wajeez-web/stores/business-group';
import { PlusIcon } from '@heroicons/react/solid';
import { AdminSystemPermissions } from '@wajeez-web/core/types';
import { Button } from '@wajeez-web/components/ui';
import { Link, useNavigate } from 'react-router-dom';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { CheckBoxType } from '@wajeez-web/components/mui';
import { DataTableWrapper } from '@wajeez-web/components/helpers';

const BusinessGroupPage = () => {
  const navigate = useNavigate();

  const { data, status } = useBusinessSelector((state) => state.businessGroups);

  const { tablePreferances, setTablePreferences, isTableReferencesLoading } =
    HandleTableData(
      'businessGroup',
      BusinessActions.getBusinessDatatableAsync,
      undefined,
      undefined,
      undefined
    );

  return (
    <div className="h-full">
      <PageLayoutsContainer
        title={`Business Group`}
        withoutRightPadding={true}
        endSideComponent={[
          {
            element: (
              <Button
                title={'Add new business'}
                Icon={PlusIcon}
                onClick={() => {
                  navigate(`create`);
                }}
                bg="primary"
                color="white"
              />
            ),
            permission: [AdminSystemPermissions.BusinessGroup.add],
          },
        ]}
        breadCrumbsLinks={[{ title: 'Business-Group' }]}
      >
        <div>
          <DataTableWrapper
            data={data as contentEntityDataType}
            onHeaderManage={(header) => {
              const flags = header
                ?.filter((h) => h.selected)
                .reduce(
                  (previousValue: number, currentValue: CheckBoxType) =>
                    previousValue + Number(currentValue.value),
                  0
                );

              tablePreferances &&
                flags &&
                setTablePreferences({
                  ...tablePreferances,
                  flags: flags + 1,
                });
            }}
            onPaginationChange={(pagination) => {
              tablePreferances &&
                setTablePreferences({
                  ...tablePreferances,
                  pageNumber: pagination.pageNumber,
                  pageSize: pagination.pageSize,
                });
            }}
            sort={tablePreferances?.sortingOperations?.[0]}
            onSort={(sort) => {
              tablePreferances &&
                setTablePreferences({
                  ...tablePreferances,
                  sortingOperations: [sort],
                });
            }}
            onFilter={(filters, pagination) => {
              tablePreferances &&
                setTablePreferences({
                  ...tablePreferances,
                  pageNumber: pagination.pageNumber,
                  filteringOperations: filters.map((f) => {
                    return {
                      property: Number(f.key),
                      cretiria: f.value,
                      comparisonType: f.operator,
                    };
                  }),
                });
            }}
            isLoading={status === 'loading'}
            rowActions={(row) => {
              return [
                {
                  title: 'Edit',
                  endpoint: '',
                  permission: AdminSystemPermissions.BusinessGroup.edit,
                  type: 'request',
                  action: () => {
                    navigate(`${row[1]}/0`);
                  },
                },
              ];
            }}
            columnsSelectors={(r) => {
              return {
                '2': (
                  <Link to={`${r[1]}/0`}>
                    <div className="text-[#38A7B4] font-medium">{r[2]}</div>
                  </Link>
                ),
              };
            }}
            preferences={tablePreferances || undefined}
            setPreferences={setTablePreferences}
          />
        </div>
      </PageLayoutsContainer>
    </div>
  );
};

export default BusinessGroupPage;
